import React, { useEffect, useState } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import SnackbarComponent from '../../components/Snackbar';
import ProfitabilityTable from '../../components/ProfitabilityTable';
import ProfitabilityChart from '../../components/ProfitabilityChart';
import request from '../../utils/request';
import { API_URL } from '../../constants';

import * as S from './styles';

const Profitability = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [chartData, setChartData] = useState(null);
  const [tableData, setTableData] = useState(null);
  const query = new URLSearchParams(useLocation().search);
  const { ticker } = useParams();
  const requestProfitabilityChartURL = `${API_URL}/${ticker}/profitability-graph`;
  const requestProfitabilityTableURL = `${API_URL}/${ticker}/profitability`;

  function getProfitabilityTable() {
    const overrideValidationParam = query.get('overrideValidation');
    return request(
      `${requestProfitabilityTableURL}${overrideValidationParam
        ? `?overrideValidation=${overrideValidationParam}`
        : ''}`,
    );
  }

  function getProfitabilityChart(dateFilterQueryParam = null) {
    return request(
      `${requestProfitabilityChartURL}${dateFilterQueryParam
        ? `?dateFilterOption=${dateFilterQueryParam}`
        : ''}`,
    );
  }

  async function getProfitabilityChartByMonth(dateFilterQueryParam) {
    try {
      const responseChartData = await getProfitabilityChart(dateFilterQueryParam);
      setChartData(responseChartData);
    } catch (error) {
      setHasError(true);
    }
  }

  useEffect(() => {
    async function getData() {
      setIsLoading(true);
      try {
        const [responseTableData, responseChartData] = await Promise.all(
          [getProfitabilityTable(), getProfitabilityChart()],
        );
        setTableData(responseTableData);
        setChartData(responseChartData);
      } catch (error) {
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    }

    getData();
  }, []);

  if (tableData && !tableData.hasAtLeastSixMonthOld) {
    return (
      <S.NotAvailableText>
        Segundo diretrizes da ANBIMA, fundos com menos de 6 meses não podem
        divulgar suas rentabilidades.
      </S.NotAvailableText>
    );
  }

  return (
    <div>
      <SnackbarComponent
        msg="Não foi possível buscar os dados da rentabilidade."
        openProps={hasError}
        variant="error"
        verticalAlign="top"
      />
      <SnackbarComponent
        msg="Carregando..."
        openProps={isLoading}
        variant="info"
        verticalAlign="top"
      />
      {(!hasError && (chartData && tableData)) && (
        <>
          <ProfitabilityChart
            data={chartData}
            onFetchProfitabilityChart={getProfitabilityChartByMonth}
          />
          <ProfitabilityTable data={tableData} />
        </>
      )}
    </div>
  );
};

export default Profitability;
